import { redirect } from "react-router";

import { store } from "../../../../..";
import {
    getGame,
    getGameRatings,
    getLeague,
    getRoster,
} from "../../../../../lib/api";

const loader = async ({ params }: any) => {
    const { leagueId, gameId } = params;

    const [{ game }, { league }] = await Promise.all([
        getGame(gameId),
        getLeague(leagueId),
    ]);

    if (game.league !== parseInt(leagueId)) {
        return redirect(`/league-management/league/${game.league}/schedule`);
    }

    const [
        { players: homeRoster },
        { players: visitorRoster },
        { ratings: umpireRatingsRaw },
    ] = await Promise.all([
        getRoster(game.home.id, game.league),
        getRoster(game.visitor.id, game.league),
        getGameRatings(gameId, "umpire"),
    ]);

    const user = store.getState().auth.user;
    const umpireRatings = umpireRatingsRaw.filter(
        r => r.ratedBy.id === parseInt(user!.id.toString()),
    );

    const header = `${league.ageLevel}${league.designation ? ` ${league.designation}` : ""}${league.direction ? ` ${league.direction}` : ""} - ${game.visitor.name} @ ${game.home.name} Game Summary`;

    return {
        leagueId,
        gameId,
        game,
        umpireRatings,
        homeRoster,
        visitorRoster,
        header,
    };
};

export default loader;
